import Button from '@mui/material/Button';
import { WrapperGraphics } from './styles';

const { VictoryChart, VictoryTheme, VictoryPolarAxis, VictoryBar } = require('victory');

const GraphicPercentage = () => {
  return (
    <>
      <div style={{ padding: '20px', fontSize: '18px' }}>
        <strong> Indicadores de Cumplimiento</strong>
      </div>
      <WrapperGraphics>
        <div className="section-bar">
          <VictoryChart polar theme={VictoryTheme.material} startAngle={0} endAngle={180} width={300} height={200}>
            <VictoryPolarAxis tickValues={[0, 100]} labelPlacement="vertical" />
            <VictoryBar style={{ data: { fill: 'green', width: 140 } }} data={[{ x: 44, y: 20 }]} />
          </VictoryChart>
          <div className="section-data">
            <strong>95%</strong>
            <div className="section-title">
              <h2>Cumplimiento de los niveles de servicio</h2>
            </div>
          </div>
        </div>
        <div className="section-bar">
          <VictoryChart polar theme={VictoryTheme.material} startAngle={0} endAngle={180} width={300} height={200}>
            <VictoryPolarAxis tickValues={[0, 100]} labelPlacement="vertical" />
            <VictoryBar style={{ data: { fill: 'yellow', width: 70 } }} data={[{ x: 21, y: 20 }]} />
          </VictoryChart>
          <div className="section-data">
            <strong>30%</strong>
            <div className="section-title">
              <h2>Desviación cumplimiento de los niveles de servicio</h2>
            </div>
          </div>
        </div>
        <div className="section-button">
          <Button variant="contained" color="success" style={{ margin: '10px', width: '90px' }}>
            Excel
          </Button>
          <Button variant="contained" color="success" style={{ margin: '10px', width: '90px' }}>
            PDF
          </Button>
        </div>
      </WrapperGraphics>
    </>
  );
};

export default GraphicPercentage;
